module.exports = __webpack_public_path__ + "img/hat_male_cap.524ce0c4.png";